import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    title: 'Plan de Arranque Rápido de 7 Días',
    desc: 'Los primeros cambios visibles en 7 días. Para el que no sabe por dónde empezar hoy.',
    value: '$30.000 ARS'
  }, {
    title: 'Checklist de Errores que Están Empeorando a Tu Perro',
    desc: '25 errores que cometés sin saberlo + corrección inmediata para cada uno. Detectalos en 15 minutos.',
    value: '$25.000 ARS'
  }, {
    title: 'Guía de Premios y Recompensas que Sí Funcionan',
    desc: 'Usá los premios de forma correcta para lograr obediencia real sin sobornos mal usados.',
    value: '$28.000 ARS'
  }, {
    title: 'Rutina Diaria del Perro Equilibrado',
    desc: 'Una rutina lista para copiar y aplicar hoy para bajar el caos y la ansiedad diaria. 4 modelos según tu estilo de vida.',
    value: '$25.000 ARS'
  }, {
    title: 'Guía Rápida para Calmar a Tu Perro en Momentos de Excitación',
    desc: 'El protocolo de 5 pasos para bajar el arousal sin gritos, sin caos, sin frustrarte. Funciona en visitas, paseo y llegada a casa.',
    value: '$28.000 ARS'
  }, {
    title: 'Plantillas de Seguimiento de Conducta y Progreso',
    desc: 'Medí el avance real de tu perro. Registro diario, semanal y mensual incluido. Dejá de adivinar si vas bien.',
    value: '$22.000 ARS'
  }];
  return <section className="py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto relative" data-id="element-20">
      <div className="absolute inset-0 bg-gold-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-21"></div>

      <div className="text-center mb-16 relative z-10" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-23">
          <div className="inline-flex items-center justify-center p-4 bg-gold-500/10 rounded-full mb-6" data-id="element-24">
            <Gift className="w-10 h-10 text-gold-400" data-id="element-25" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-26">
            🎁 LOS 6 BONOS
          </h2>
          <p className="text-xl text-blue-200" data-id="element-27">
            Más los 6 Bonos Estratégicos Incluidos en todas las ofertas — sin
            costo extra
          </p>
        </motion.div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 relative z-10" data-id="element-28">
        {bonuses.map((bonus, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-navy-800/80 border border-navy-600 p-6 rounded-2xl relative overflow-hidden group flex flex-col" data-id="element-29">
            <div className="absolute top-0 right-0 bg-gold-500 text-navy-900 text-xs font-bold px-3 py-1 rounded-bl-lg z-10" data-id="element-30">
              BONO {index + 1}
            </div>

            <h4 className="text-xl font-bold text-white mb-3 pr-16 mt-2" data-id="element-31">
              {bonus.title}
            </h4>
            <p className="text-blue-100/80 text-sm mb-6 flex-grow" data-id="element-32">
              {bonus.desc}
            </p>

            <div className="flex items-center justify-between mt-auto pt-4 border-t border-navy-700" data-id="element-33">
              <span className="text-gray-400 line-through text-sm" data-id="element-34">
                {bonus.value}
              </span>
              <span className="text-green-400 font-bold" data-id="element-35">GRATIS</span>
            </div>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="mt-16 text-center bg-navy-800/50 border border-gold-500/50 py-6 px-8 rounded-2xl max-w-3xl mx-auto relative z-10" data-id="element-36">
        <p className="text-xl md:text-2xl text-white" data-id="element-37">
          Valor total de los 6 Bonos:{' '}
          <span className="line-through text-gray-400" data-id="element-38">$158.000 ARS</span>{' '}
          <span className="text-gold-400 font-bold ml-2" data-id="element-39">→ GRATIS</span>
        </p>
        <p className="text-blue-200/80 mt-2 text-sm uppercase tracking-wider" data-id="element-40">
          Incluidos siempre en las dos ofertas
        </p>
      </motion.div>
    </section>;
}